import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { ReportComponent } from "../components";

class CPOReport extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "cpo_report",
            title: "CPO Report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "CPO Report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <ReportComponent />
            </Base>
        );
    }
}

export default CPOReport;
